import { createFileRoute } from "@tanstack/react-router";
import { ORG } from "@/app/capabilities/permissions";
import { organizationLoggingQueryOptions } from "@/app/organization-logging/api/get-organization-logging";
import { LoggingSettingsError } from "@/app/organization-logging/components/logging-settings-error";
import { OrganizationLoggingPage } from "@/app/organization-logging/page";
import { requireOneOfOrgPermission } from "@/lib/route-guards";

export const Route = createFileRoute(
  "/_authenticated/orgs/$organizationId/projects/$projectId/organization/logging"
)({
  beforeLoad: async (ctx) => {
    // Reading the policy is org-metadata; changing it is gated separately in the
    // form, so someone who may only look still gets the page.
    await requireOneOfOrgPermission(ctx, [ORG.orgMetadata.read]);
    ctx.context.queryClient.prefetchQuery(
      organizationLoggingQueryOptions(ctx.params.organizationId)
    );
  },
  loader: () => ({
    crumb: "Logging Policy",
  }),
  // The page owns its own loading boundary, so it renders directly here.
  component: OrganizationLoggingPage,
  errorComponent: LoggingSettingsError,
});
